import request, { REQUEST_METHODS } from '@api/Request';
import { ArcGisEndpoints } from './config';
import type { ArcGisCountyResponse } from './types';

export const ArcGisService = {
  getCountyListByState: async (stateName: string): Promise<string[]> => {
    const params = new URLSearchParams({
      f: 'json',
      where: `STATE_NAME='${stateName}'`,
      returnGeometry: 'false',
      returnDistinctValues: 'true',
      outFields: 'NAME',
    });

    const data = await request<ArcGisCountyResponse>({
      url: ArcGisEndpoints.getCountyListByState(),
      method: REQUEST_METHODS.POST,
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
      data: params.toString(),
      skipAuth: true,
    });

    if (!data.features || !Array.isArray(data.features)) {
      throw new Error('Invalid response format from ArcGIS');
    }

    return data.features.map((feature) => feature?.attributes?.NAME).filter(Boolean);
  },
};
